module.exports = __webpack_public_path__ + "img/arabesque-arabic-flower-1011548.e88a129d.svg";